<template>
  <div class="ipo-subscription">
    <div class="overlay"></div>
    <div class="wrap">
      <div class="header">
        <img src="@/assets/images/dark/ipo-dialog-header/背景@2x.png" class="background" alt="" />
        <p class="title">港股可认购新股</p>
        <img src="@/assets/images/dark/ipo-dialog-header/手机@2x.png" class="phone" alt="" />
        <img src="@/assets/images/dark/ipo-dialog-header/草@2x.png" class="grass" alt="" />
        <img
          src="@/assets/images/dark/ipo-dialog-header/关闭@2x.png"
          class="close"
          alt=""
          @click="$emit('show', false)"
        />
      </div>
      <ul class="list">
        <li class="item" v-for="item in data" :key="item.symbol">
          <div class="up">
            <div class="name">{{ item.stockBaseInfo.stockName }}</div>
            <div class="price">{{ item.publishedData.admissionFee }}HKD</div>
          </div>
          <div class="down">
            <div class="code">
              <!-- <span class="logo">{{ item.stockBaseInfo.symbol.slice(-2) }}</span> -->
              <span>{{ item.stockBaseInfo.symbol }}</span>
            </div>
            <div class="date">截至日期：{{ $dayjs(item.publishedData.subEndDate).format('YYYY-MM-DD') }}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.ipo-subscription {
  .overlay {
    position: fixed;
    background: rgba(0, 0, 0, 0.3);
    width: 100vw;
    height: 100vh;
  }
  .wrap {
    position: fixed;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 578px;
    .header {
      position: relative;
      .title {
        font-size: 36px;
        font-weight: bold;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .background {
        width: 100%;
      }
      .phone {
        position: absolute;
        bottom: 8px;
        left: -36px;
        height: 160px;
      }
      .grass {
        position: absolute;
        bottom: 8px;
        right: -40px;
        height: 120px;
      }
      .close {
        background: black;
        border-radius: 50%;
        width: 30px;
        position: absolute;
        top: -30px;
        right: -30px;
      }
    }
    .list {
      margin-top: -10px;
      background: var(--bg-color-3);
      border-radius: 0 0 24px 24px;
      .item {
        padding: 20px 24px;
        .up {
          padding-bottom: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .name {
            font-size: 32px;
            font-weight: bold;
          }
          .price {
            font-size: 28px;
          }
        }
        .down {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .code {
            font-size: 24px;
            color: var(--font-color-2);
            .logo {
              border: 1px solid red;
              color: red;
              font-size: 16px;
            }
          }
          .date {
            font-size: 24px;
            color: var(--font-color-2);
          }
        }
      }
    }
  }
}
</style>
